import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEraserSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEraserSimple"><Path d="M6.50015 9.08569L14.0002 1.58569L22.4144 9.99991L14.9144 17.4999L6.50015 9.08569Z" fill="currentColor"/><Path d="M5.08594 10.4999L1.58594 13.9999L10.0002 22.4141L13.5002 18.9141L5.08594 10.4999Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEraserSimple;
